import styled from 'styled-components';
import {typographyStyle} from '@/components/Typography';
import {ColumnFlexBox} from '@/styled-components';
import {palette} from '@/styles';

export const MoreMenuGroup = styled(ColumnFlexBox)`
  background-color: ${palette.white};
  gap: 16px;
  padding: 8px 0;
`;

export const MoreMenuItem = styled.div`
  ${{...typographyStyle.medium14}}
  display: block;
  padding: 15px 16px;
  color: ${palette.gray800};
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background-color: ${palette.gray100};
  }
`;
